/**
 * Copyright Fitzba Technologies Inc. 2023
 * 
 * ImageList.js exports a React component named 'ImageList'. This component displays a list of images for a specific item.
 * The user can click on the left or right arrows to navigate through the images. The currently displayed image is indicated by a border around the image in the list below the main image.
 * 
 * The component takes three props: 'images', 'name', and 'isUsed'. 'images' is an array of image URLs. 'name' is the name of the item. 'isUsed' is a boolean indicating whether the item is used.
 * 
 * @author Yang Ming
 * @version January 19th, 2024
 */

import React from 'react'
import { HiOutlineChevronLeft, HiOutlineChevronRight } from 'react-icons/hi'
import ImagePreOwned from './ImagePreOwned'
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import FavoriteButton from './FavoriteButton'
import CanadianBrandIcon from './CanadianBrandIcon'
/**
 * A component that displays a list of images for a specific item.
 * 
 * @param {Object} props - The props object.
 * @param {Array} props.images - An array of image URLs.
 * @param {string} props.name - The name of the item.
 * @param {boolean} props.isUsed - A boolean indicating whether the item is used.
 * @returns {JSX.Element} The 'ImageList' component.
 */
export default function ServiceImageList({
  service,
}) {
  // const [imageIndex, setImageIndex] = useState(0)
  let image = service?.image || service?.business?.logo
  return (
    <div className='flex flex-1 flex-col items-center pb-10 sm:pb-20'>
      <div className='relative flex items-center justify-center h-[300px] w-[300px] rounded-xl border border-[#000] border-opacity-10 sm:h-[500px] sm:w-[500px]'>
        <Zoom>
          <img
            src={image}
            alt={service?.title}
            className='w-full h-[295px] sm:h-[495px] object-contain rounded-[10px]'
          />
        </Zoom>
      </div>
    </div>
  )
}

